import { Link, useLocation } from 'react-router-dom'
import {
  animeSchedule,
  articelsHomePageImages,
  footerImages,
  images,
} from '../services/images.service'
import { addEmailToMailingList } from '../services/mailingList.service'
import { useState } from 'react'
import toast from 'react-hot-toast'
import {
  DiscordIcon,
  InstagramIcon,
  TelegramIcon,
  TiktokIcon,
  YoutubeIcon,
} from './ui/icons/shared'

const animeList1 = [
  {
    id: 52991,
    slug: 'Frieren_Beyond_Journeys_End',
    title: 'פרירן: מעבר לסופו של המסע',
  },
  {
    id: 5114,
    slug: 'Fullmetal_Alchemist_Brotherhood',
    title: 'אלכימאי המתכת: אחוות הברזל',
  },
  { id: 60022, slug: 'One_Piece_Fan_Letter', title: 'מכתב מעריץ של וואן פיס' },
  { id: 9253, slug: 'SteinsGate', title: 'שטיינס;גייט' },
  { id: 28977, slug: 'Gintama_Season_4', title: 'גינטאמה עונה 4' },
  {
    id: 38524,
    slug: 'Attack_on_Titan_Season_3_Part_2',
    title: 'מתקפת הטיטאנים עונה 3 חלק 2',
  },
  {
    id: 39486,
    slug: 'Gintama_The_Very_Final',
    title: 'גינטאמה: דה וורי פיינל',
  },
  { id: 9969, slug: 'Gintama_Season_2', title: 'גינטאמה עונה 2' },
  { id: 11061, slug: 'Hunter_x_Hunter', title: 'האנטר x האנטר' },
  { id: 15417, slug: 'Gintama_Enchousen', title: "גינטאמה: אנצ'וסן" },
  {
    id: 820,
    slug: 'Legend_of_the_Galactic_Heroes',
    title: 'אגדת גיבורי הגלקסיה',
  },
  {
    id: 41467,
    slug: 'Bleach_Thousand-Year_Blood_War',
    title: 'בליץ’: מלחמת הדם בת אלף השנים',
  },
  {
    id: 43608,
    slug: 'Kaguya-sama_Love_is_War_-Ultra_Romantic-',
    title: 'קאגויה-סאמה: אהבה היא מלחמה -אולטרה רומנטי-',
  },
  { id: 34096, slug: 'Gintama_Season_5', title: 'גינטאמה עונה 5' },
  {
    id: 42938,
    slug: 'Fruits_Basket_The_Final_Season',
    title: 'סלסילת פירות עונה שלישית',
  },
]

const animeList2 = [
  { id: 4181, slug: 'Clannad_After_Story', title: 'קלאנד: הסיפור שאחרי' },
  { id: 28851, slug: 'A_Silent_Voice', title: 'קול שקט' },
  { id: 918, slug: 'Gintama', title: 'גינטאמה' },
  {
    id: 2904,
    slug: 'Code_Geass_Lelouch_of_the_Rebellion_R2',
    title: 'קוד גיאס: המרד של ללוש R2',
  },
  {
    id: 35180,
    slug: 'March_Comes_In_Like_a_Lion_2nd_Season',
    title: 'מרץ מגיע כמו אריה עונה שנייה',
  },
  {
    id: 15335,
    slug: 'Gintama_The_Movie_The_Final_Chapter_Be_Forever_Yorozuya',
    title: 'גינטאמה: הסרט: הפרק האחרון: להיות לנצח יורוזויה',
  },
  {
    id: 37491,
    slug: 'Gintama_Silver_Soul_Arc_-_Second_Half_War',
    title: 'גינטאמה. קשת הנשמה הכסופה - מלחמת החצי השני',
  },
  {
    id: 54492,
    slug: 'The_Apothecary_Diaries',
    title: 'יומני הרוקחת - תרגום Lemon Sub',
  },
  { id: 19, slug: 'Monster', title: 'מפלצת' },
  {
    id: 35247,
    slug: 'Owarimonogatari_Second_Season',
    title: 'אווארימונוגאטארי עונה שנייה',
  },
  {
    id: 51535,
    slug: 'Attack_on_Titan_Final_Season_-_The_Final_Chapters',
    title: 'מתקפת הטיטאנים עונת סיום חלק אחרון',
  },
  {
    id: 37987,
    slug: 'Violet_Evergarden_The_Movie',
    title: 'ויולט אברגרדן: הסרט',
  },
  { id: 40682, slug: 'Kingdom_Season_3', title: 'קינגדום: עונה 3' },
  { id: 32281, slug: 'Your_Name', title: 'שמך.' },
]

export function Footer() {
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [isChecked, setIsChecked] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!email.includes('@') || !email.includes('.')) {
      toast.error('נא להזין אימייל תקין.')
      return
    }

    if (!isChecked) {
      toast.error('נא לאשר קבלת עדכונים.')
      return
    }

    try {
      const response = await addEmailToMailingList(email)
      if (response.success) {
        toast.success(response.message)
        setEmail('')
        setIsChecked(false)
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      toast.error('שגיאה במהלך ההרשמה.')
      console.error(error)
    }
  }

  return (
    <>
      <div className="h-[660px] relative mt-[100px]">
        <div className="grid grid-cols-[70%_30%] relative">
          <div className="flex gap-20 w-[1260px]">
            <div className="flex flex-col self-start justify-center gap-8 p-6">
              <img src={images.logo} alt="AniZone logo" />
              <ul className="flex justify-center items-center gap-4">
                <li>
                  <a
                    href="https://www.tiktok.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                  >
                    <TiktokIcon />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <YoutubeIcon />
                  </a>
                </li>
                <li>
                  <a
                    href="http://t.me/anizoneil"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Telegram"
                  >
                    <TelegramIcon />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <InstagramIcon />
                  </a>
                </li>
                <li>
                  <a
                    href="https://discord.gg/uGpcw4ayCr"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Discord"
                  >
                    <DiscordIcon />
                  </a>
                </li>
              </ul>

              <div className="mt-16">
                <div className="flex flex-col justify-center items-center gap-2 mb-4">
                  <h4 className="text-text">
                    קבל עדכונים רלוונטים לאנימה בישראל, אירועים ועוד.
                  </h4>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="relative">
                    <input
                      className="p-4 text-softText bg-[#424242] w-full"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="אימייל"
                      required
                    />
                    <button
                      type="submit"
                      className="absolute z-50 top-1/2 left-2 transform -translate-y-1/2"
                    >
                      <img src={footerImages.addmeBtn} alt="Add me" />
                      <span className="absolute w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        צרפו אותי
                      </span>
                    </button>
                  </div>
                  <label className="flex gap-2 mt-2">
                    <input
                      type="checkbox"
                      className="accent-primary w-[31px] h-[26px]"
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                    />
                    <span className="text-softText text-lg">
                      אני מאשר קבלת עדכונים מאניזון
                    </span>
                  </label>
                </form>
              </div>

              <div className="flex items-center justify-center gap-4">
                <Link to="/privacy-policy">
                  <h6 className="text-muted">מדיניות הפרטיות</h6>
                </Link>
                <span className="bg-[#464646] w-3 h-3 rounded-full"></span>
                <Link to="/accessibility-statement">
                  <h6 className="text-muted">הצהרת נגישות</h6>
                </Link>
                <span className="bg-[#464646] w-3 h-3 rounded-full"></span>
                <Link to="/terms-of-use">
                  <h6 className="text-muted">תנאי שימוש</h6>
                </Link>
              </div>
            </div>
            <div className="flex gap-10">
              <div className="text-softText">
                <div>
                  <p>אנימות</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="308"
                    height="10"
                    viewBox="0 0 308 10"
                    fill="none"
                  >
                    <path d="M0 0V10H308V6.71053L0 0Z" fill="#363636" />
                  </svg>
                </div>
                <div className="flex gap-8">
                  <ul className="mt-4 flex flex-col gap-3">
                    {animeList1.map((anime) => (
                      <li key={anime.id} className="text-sm">
                        <Link
                          to={`/anime/${anime.id}/${anime.slug}`}
                          className="font-hebrew"
                        >
                          {anime.title}
                        </Link>
                      </li>
                    ))}
                    <li>
                      <Link to="/animes">
                        <h5 className="text-primary text-lg font-yarden mt-4 font-hebrew">
                          לכל האנימות
                        </h5>
                      </Link>
                    </li>
                  </ul>
                  <ul className="mt-4 flex flex-col gap-3">
                    {animeList2.map((anime) => (
                      <li key={anime.id} className="text-sm">
                        <Link
                          to={`/anime/${anime.id}/${anime.slug}`}
                          className="font-hebrew"
                        >
                          {anime.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="relative bottom-[-50px]">
            <img
              className="lg:hidden xl:block"
              src={footerImages.characterMain}
              alt="Character"
            />
          </div>
        </div>
      </div>
    </>
  )
}
